// src/modules/auth/hooks/useAuth.ts
import { useContext } from "react";
import { AuthContext } from "../AuthProvider";
import { User } from "../types";

export interface LoginOptions {
  isPosLogin?: boolean;
}

export interface BusinessOwner {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}

export interface BasicRegisterData {
  business_name: string;
  owner: BusinessOwner;
}

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  login: (
    email: string,
    password: string,
    options?: LoginOptions
  ) => Promise<void>;
  logout: () => Promise<void>;
  register: (values: BasicRegisterData) => Promise<void>;
  changePassword: (
    currentPassword: string,
    newPassword: string
  ) => Promise<void>;
}

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
